import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import Layout from '../views/layout/index.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  return (originalPush.call(this, location) as any).catch((err: any) => err);
};

/**
 * TIPS:
 * meta: {
 *   requireAuth: false,
 * }
 */
const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      requireAuth: false,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue'),
  },
  {
    path: '/home',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "home" */ '../views/home/index.vue'),
        name: 'Home',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: '/assgin',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "assgin" */ '../views/assgin/index.vue'),
        name: 'Assgin',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: '/assginFilter',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "assginFilter" */ '../views/assgin/filter.vue'),
        name: 'AssginFilter',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: '/pickup',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "pickup" */ '../views/pickup/index.vue'),
        name: 'Pickup',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: '/pickupFilter',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "pickupFilter" */ '../views/pickup/filter.vue'),
        name: 'PickupFilter',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: '/locationSetting',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "locationSetting" */ '../views/setting/location.vue'),
        name: 'LocationSetting',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
